import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";

interface WorkContractStatusFieldsProps {
  profile: any;
  setProfile: (profile: any) => void;
  readOnly: boolean;
  loading: boolean;
}

export function WorkContractStatusFields({
  profile,
  setProfile,
  readOnly,
  loading
}: WorkContractStatusFieldsProps) {
  const contractStatus = profile?.work_contract_status || "not_applied";

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-1">
        <div className="flex items-center gap-1">
          <label className="text-sm font-medium">Status</label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Was ist der aktuelle Status des Arbeitsvertrags?</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Select
          disabled={readOnly}
          value={contractStatus}
          onValueChange={(value) =>
            setProfile({
              ...profile!,
              work_contract_status: value as
                | "not_applied"
                | "applied"
                | "received"
                | "signed"
            })
          }
        >
          <SelectTrigger loading={loading}>
            <SelectValue placeholder="Bitte auswählen" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="not_applied">Nicht beantragt</SelectItem>
            <SelectItem value="applied">Beantragt</SelectItem>
            <SelectItem value="received">Erhalten</SelectItem>
            <SelectItem value="signed">Unterschrieben</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {(contractStatus === "received" || contractStatus === "signed") && (
        <div className="space-y-1">
          <div className="flex items-center gap-1">
            <label className="text-sm font-medium">
              Art des Arbeitsvertrags
            </label>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <HelpCircle className="h-4 w-4 text-gray-400" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>Ist es ein vorläufiger oder endgültiger Arbeitsvertrag?</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
          <Select
            disabled={readOnly}
            value={profile?.work_contract_type}
            onValueChange={(value) =>
              setProfile({ ...profile!, work_contract_type: value })
            }
          >
            <SelectTrigger>
              <SelectValue placeholder="Bitte auswählen" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="temporary">
                Vorläufiger Arbeitsvertrag
              </SelectItem>
              <SelectItem value="permanent">
                Endgültiger Arbeitsvertrag
              </SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
}
